export default __webpack_public_path__ + "static/media/phoneclear.88a95258.svg";